import { ToastProvider } from "@closer/ui";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router/dom";

import { AuthProvider } from "./lib/authContext";
import { PreferencesProvider } from "./lib/preferences";
import { queryClient } from "./lib/queryClient";
import { router } from "./router";

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          {/* Tercihler AuthProvider'ın İÇİNDE: hesap tercihi oturum olmadan yüklenemez. */}
          <PreferencesProvider>
            <RouterProvider router={router} />
          </PreferencesProvider>
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  );
}
